import { render, staticRenderFns } from "./PortArView.vue?vue&type=template&id=3ed4c999&scoped=true"
import script from "./PortArView.vue?vue&type=script&lang=js"
export * from "./PortArView.vue?vue&type=script&lang=js"
import style0 from "./PortArView.vue?vue&type=style&index=0&id=3ed4c999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4c999",
  null
  
)

export default component.exports